/* eslint-disable */

import moment from 'moment';
import { getCurrentUser, getOrganizations, getOrganization } from '../actions';
import { enums } from '../../src/enums/';

/* CONSTANTS */
const CONNECTION = 'Username-Password-Authentication';
const BLOCKCHAINADDRESS = '0x004....';

export const sortUsers = (users, order, orderBy) => dispatch => {
  dispatch({ type: 'SORT_USERS', payload: { users, order, orderBy } });
};

export const changePage = page => dispatch => {
  dispatch({ type: 'CHANGE_PAGE', payload: { page } });
};

export const changeRowsPerPage = rowsPerPage => dispatch => {
  dispatch({ type: 'CHANGE_ROWS_PER_PAGE', payload: { rowsPerPage } });
};

export const fetchAssetProduction = async (prodAssetId, start, end) => {
  //First, we get the producing assets related to this consuming asset

  let url =
    process.env.REACT_APP_API_URL +
    '/producing-assets/' +
    prodAssetId +
    '/production?';
  url += start ? '&start=' + start : '';
  url += end ? '&end=' + end : '';

  return await fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  })
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(error => {
      console.error(error);
    });
};

export const getGraphDataProducer = async prodAssetId => {
  const reqSiteTimeSeries = await fetchAssetProduction(prodAssetId);

  let barChartLabels = reqSiteTimeSeries.dates;
  let barChartData = {
    data: reqSiteTimeSeries.production,
    label: reqSiteTimeSeries.asset.displayedName,
  };
  let barChartDataMatched = {
    data: reqSiteTimeSeries.matchedProduction,
    label: reqSiteTimeSeries.asset.displayedName,
  };

  let dataResidual = reqSiteTimeSeries.production.map((prod, index) => {
    let matchedProd = reqSiteTimeSeries.matchedProduction[index];
    return prod - matchedProd;
  });

  let barChartDataResidual = {
    data: dataResidual,
    label: reqSiteTimeSeries.asset.displayedName,
  };

  let graphData = {
    barChartData,
    barChartDataMatched,
    barChartDataResidual,
    barChartLabels,
  };

  return graphData;
};

export const createUserStart = (
  currentUser,
  history,
  relatedConsAssetsList,
  file
) => async dispatch => {
  if (
    !currentUser.user_metadata.organization ||
    !currentUser.user_metadata.organization._id
  ) {
    dispatch({
      type: 'OPEN_ERROR',
      payload: 'Please specify an organization !',
    });
    return;
  }

  let relatedConsAssets = relatedConsAssetsList.map(consAsset => {
    return consAsset.id;
  });

  currentUser.user_metadata.consumingSites = relatedConsAssets;
  currentUser.app_metadata.realAccount = true;

  dispatch({ type: 'CREATE_USER_START' });

  try {
    await createUser(currentUser, file);
  } catch (error) {
    console.error(error);
    createUserFail('Error creating empty user', dispatch);
  }

  history.push('/users/');
};

export const createUserSuccess = (userId, owner, history, dispatch) => {
  dispatch({ type: 'CREATE_USER_SUCCESS' });
  dispatch({ type: 'OPEN_SUCCESS', payload: 'New user created !' });

  history.push('/assets/prod/' + userId);
};

export const createUserFail = (error, dispatch) => {
  dispatch({ type: 'CREATE_USER_FAIL' });
  dispatch({ type: 'OPEN_ERROR', payload: error });
};

export const updateUserStart = (
  userId,
  user,
  history,
  relatedConsAssetsList,
  file
) => async dispatch => {
  const currentUser = await getCurrentUser();

  if (
    !user.user_metadata.organization ||
    !user.user_metadata.organization._id
  ) {
    dispatch({
      type: 'OPEN_ERROR',
      payload: 'Please specify an organization !',
    });
    return;
  }

  let relatedConsAssets = relatedConsAssetsList.map(consAsset => {
    return consAsset.id;
  });

  user.user_metadata.consumingSites = relatedConsAssets;

  dispatch({ type: 'UPDATE_USER_START' });

  await setUser(userId, user).catch(error => {
    dispatch({ type: 'UPDATE_USER_FAIL' });
    dispatch({ type: 'OPEN_ERROR', payload: 'Error updating user' });
  });

  if (file) {
    user.pictureFileName = await uploadUserPicture(file, user, userId);
    await setUser(userId, user).catch(error => {
      dispatch({ type: 'UPDATE_USER_FAIL' });
      dispatch({ type: 'OPEN_ERROR', payload: 'Error updating user' });
    });
  }

  dispatch({ type: 'UPDATE_USER_SUCCESS' });
  dispatch({ type: 'OPEN_SUCCESS', payload: 'User updated !' });

  history.push('/users/');
};

export const updateUserSuccess = (userId, owner, history, dispatch) => {
  dispatch({ type: 'UPDATE_USER_SUCCESS' });
  dispatch({ type: 'OPEN_SUCCESS', payload: 'Asset updated !' });
  history.push('/assets/prod/' + userId);
};

export const updateUserFail = (error, dispatch) => {
  dispatch({ type: 'UPDATE_USER_FAIL' });
  dispatch({ type: 'OPEN_ERROR', payload: error });
};

export const getUserStart = userId => async dispatch => {
  dispatch({ type: 'GET_USER_START' });
  try {
    let user = await getUser(userId);
    dispatch({ type: 'GET_USER_SUCCESS', payload: user });
  } catch (error) {
    dispatch({ type: 'OPEN_ERROR', payload: "This user can't be retrieved" });
    dispatch({ type: 'GET_USER_FAIL' });
  }
};

export const getUserFormStart = userId => async dispatch => {
  dispatch({ type: 'GET_USER_FORM_START' });

  let user = await getUser(userId);
  await dispatch(getOrganizations());
  dispatch({ type: 'GET_USER_FORM_SUCCESS', payload: user });
  return user;
};

export const updateFormUserConsumingAssetList = user => dispatch => {
  dispatch({ type: 'FORM_USER_CONSUMING_ASSET_LIST_CHANGED', payload: user });
};

export const resetCurrentUser = () => async dispatch => {
  dispatch({ type: 'RESET_USER' });
};

export const userHasRole = (user, role) => {
  let roleArray = user.roles;

  for (let currentRole of roleArray) {
    if (currentRole === role) {
      return true;
    }
  }

  return false;
};

// IIFE to scope internal variables
var float64ToInt64Binary = () => {
  // create union
  var flt64 = new Float64Array(1);
  var uint16 = new Uint16Array(flt64.buffer);
  // 2**53-1
  var MAX_SAFE = 9007199254740991;
  // 2**31
  var MAX_INT32 = 2147483648;

  function uint16ToBinary() {
    var bin64 = '';

    // generate padded binary string a word at a time
    for (var word = 0; word < 4; word++) {
      bin64 = uint16[word].toString(2).padStart(16, 0) + bin64;
    }

    return bin64;
  }

  return function float64ToInt64Binary(number) {
    // NaN would pass through Math.abs(number) > MAX_SAFE
    if (!(Math.abs(number) <= MAX_SAFE)) {
      throw new RangeError('Absolute value must be less than 2**53');
    }

    var sign = number < 0 ? 1 : 0;

    // shortcut using other answer for sufficiently small range
    if (Math.abs(number) <= MAX_INT32) {
      return (number >>> 0).toString(2).padStart(64, sign);
    }

    // little endian byte ordering
    flt64[0] = number;

    // subtract bias from exponent bits
    var exponent = ((uint16[3] & 0x7ff0) >> 4) - 1022;

    // encode implicit leading bit of mantissa
    uint16[3] |= 0x10;
    // clear exponent and sign bit
    uint16[3] &= 0x1f;

    // check sign bit
    if (sign === 1) {
      // apply two's complement
      uint16[0] ^= 0xffff;
      uint16[1] ^= 0xffff;
      uint16[2] ^= 0xffff;
      uint16[3] ^= 0xffff;
      // propagate carry bit
      for (var word = 0; word < 3 && uint16[word] === 0xffff; word++) {
        // apply integer overflow
        uint16[word] = 0;
      }

      // complete increment
      uint16[word]++;
    }

    // only keep integer part of mantissa
    var bin64 = uint16ToBinary().substr(11, Math.max(exponent, 0));
    // sign-extend binary string
    return bin64.padStart(64, sign);
  };
};
const dec2bin = dec => {
  return (dec >>> 0).toString(2);
};

export const getUser = async userId => {
  try {
    const user = await getUserData(userId);
    return user;
  } catch (error) {
    throw Error(error);
  }
};

export const getUserData = async userId => {
  return await fetch(process.env.REACT_APP_API_URL + '/api/users/' + userId, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  })
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(error => {
      throw Error(error);
    });
};

export const getUserProperties = async (sender, assetId) => {
  return await fetch(
    process.env.REACT_APP_API_URL +
      '/producing-assets/' +
      assetId +
      '/properties?_sender=' +
      sender,
    {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(error => {
      console.error(error);
    });
};

export const getUserLocation = async (sender, assetId) => {
  return await fetch(
    process.env.REACT_APP_API_URL +
      '/producing-assets/' +
      assetId +
      '/location?_sender=' +
      sender,
    {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    }
  )
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(error => {
      console.error(error);
    });
};

export const getUserSuccess = (assetId, dispatch) => {
  dispatch({ type: 'GET_USER_SUCCESS' });
};

export const getUserFail = (assetId, dispatch) => {
  dispatch({ type: 'GET_USER_FAIL' });
};

export const rolesListChanged = (newRole, currentUser) => dispatch => {
  let rolesArray = [];

  if (currentUser.app_metadata && currentUser.app_metadata.roles && !!newRole) {
    rolesArray = filterOldRolesList(newRole, currentUser);
  }

  const index = rolesArray.indexOf(newRole);

  if (index < 0) {
    rolesArray.push(newRole);
  }

  dispatch({ type: 'ROLES_CHANGED', payload: rolesArray });
};

export const filterOldRolesList = (newRole, currentUser) => {
  if (newRole === enums.UserRole.ADMIN)
    return currentUser.app_metadata.roles.filter(role => {
      return (
        role != enums.UserRole.CUSTOMER && role != enums.UserRole.SUPER_ADMIN
      );
    });

  if (newRole === enums.UserRole.SUPER_ADMIN)
    return currentUser.app_metadata.roles.filter(role => {
      return role != enums.UserRole.CUSTOMER && role != enums.UserRole.ADMIN;
    });

  if (newRole === enums.UserRole.CUSTOMER)
    return currentUser.app_metadata.roles.filter(role => {
      return role != enums.UserRole.ADMIN && role != enums.UserRole.SUPER_ADMIN;
    });
};

export const deliveriesRoleChanged = currentUser => dispatch => {
  let rolesArray;
  if (currentUser.app_metadata && currentUser.app_metadata.roles)
    rolesArray = currentUser.app_metadata.roles;
  else rolesArray = [];
  const index = rolesArray.indexOf(enums.UserRole.HAS_DELIVERIES);
  if (index > -1) {
    rolesArray = rolesArray.filter(role => {
      return role != enums.UserRole.HAS_DELIVERIES;
    });
  } else {
    rolesArray.push(enums.UserRole.HAS_DELIVERIES);
  }

  dispatch({ type: 'ROLES_CHANGED', payload: rolesArray });
};

export const firstNameChanged = firstName => dispatch => {
  dispatch({ type: 'FIRST_NAME_CHANGED', payload: firstName });
};

export const lastNameChanged = lastName => dispatch => {
  dispatch({ type: 'LAST_NAME_CHANGED', payload: lastName });
};

export const userNameChanged = userName => dispatch => {
  dispatch({ type: 'USER_NAME_CHANGED', payload: userName });
};

export const phoneNumberChanged = phoneNumber => dispatch => {
  dispatch({ type: 'PHONE_NUMBER_CHANGED', payload: phoneNumber });
};

export const realAccountChanged = realAccount => dispatch => {
  dispatch({ type: 'REAL_ACCOUNT_CHANGED', payload: realAccount });
};

export const surnameChanged = surname => dispatch => {
  dispatch({ type: 'SURNAME_CHANGED', payload: surname });
};

export const organizationChanged = organization => dispatch => {
  dispatch({ type: 'ORGANIZATION_CHANGED', payload: organization });
  dispatch({ type: 'FORM_USER_CONSUMING_ASSET_LIST_RESET' });
};

export const emailChanged = email => dispatch => {
  dispatch({ type: 'EMAIL_CHANGED', payload: email });
};

export const rolesChanged = roles => dispatch => {
  dispatch({ type: 'ROLES_CHANGED', payload: roles });
};
export const typeChanged = type => dispatch => {
  dispatch({ type: 'TYPE_CHANGED', payload: type });
};

export const toggleAdminRoleChanged = () => dispatch => {
  dispatch({ type: 'ROLES_ADMIN_CHANGED' });
};

export const toggleUserAdminRoleChanged = () => dispatch => {
  dispatch({ type: 'ROLES_USER_ADMIN_CHANGED' });
};

export const toggleAssetAdminRoleChanged = () => dispatch => {
  dispatch({ type: 'ROLES_ASSET_ADMIN_CHANGED' });
};

export const toggleAgreementAdminRoleChanged = () => dispatch => {
  dispatch({ type: 'ROLES_AGREEMENT_ADMIN_CHANGED' });
};

export const toggleAssetManagerRoleChanged = () => dispatch => {
  dispatch({ type: 'ROLES_ASSET_MANAGER_CHANGED' });
};

export const toggleTraderRoleChanged = () => dispatch => {
  dispatch({ type: 'ROLES_TRADER_CHANGED' });
};

export const toggleMatcherRoleChanged = () => dispatch => {
  dispatch({ type: 'ROLES_MATCHER_CHANGED' });
};

export const activeUserChanged = active => dispatch => {
  dispatch({ type: 'ACTIVE_USER_CHANGED', payload: active });
};

export const addressChanged = address => dispatch => {
  dispatch({ type: 'ADDRESS_CHANGED', payload: address });
};

const handleErrors = response => {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
};

const handleCatchedErrors = err => {
  throw Error(err);
};

export const getConsumptionSitesList = async () => {
  try {
    let response = await fetch(process.env.REACT_APP_API_URL + '/api/consum/', {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    });

    handleErrors(response);

    let data = await response.json();

    return data;
  } catch (error) {
    handleCatchedErrors(error);
  }
};

export const getConsumptionSitesByOrganization = organizationId => async dispatch => {
  try {
    let response = await fetch(
      `${
        process.env.REACT_APP_API_URL
      }/api/consum/organization/${organizationId}`,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
      }
    );

    handleErrors(response);

    let data = await response.json();
    dispatch({
      type: 'ORGANIZATION_CONSUMPTION_ASSETS_CHANGED',
      payload: data,
    });
  } catch (error) {
    handleCatchedErrors(error);
  }
};

export const getUsersLength = async sender => {
  return await fetch(
    process.env.REACT_APP_API_URL +
      '/producing-assets-list-length?_sender=' +
      sender,
    {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    }
  )
    .then(handleErrors)
    .then(async res => res.json())
    .then(async userListLength => {
      return userListLength;
    })
    .catch(error => {
      console.error(error);
    });
};

export const getUsersStart = () => async dispatch => {
  dispatch({ type: 'GET_USERS_START' });
  return await fetch(process.env.REACT_APP_API_URL + '/api/users/', {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  })
    .then(handleErrors)
    .then(async res => res.json())
    .then(async users => {
      getUsersSuccess(users, dispatch);
    })
    .catch(error => {
      console.error(error);
      getUsersFail(error, dispatch);
    });
};

export const getUsersSuccess = (users, dispatch) => {
  dispatch({ type: 'GET_USERS_SUCCESS', payload: users });
};

export const getUsersFail = (error, dispatch) => {
  dispatch({ type: 'GET_USERS_FAIL' });
};

export const getAllConsumingSites = async () => {
  try {
    let response = await fetch(process.env.REACT_APP_API_URL + '/api/consum', {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
    });
    handleErrors(response);

    let data = await response.json();
    return data;
  } catch (error) {
    handleCatchedErrors(error);
  }
};

const createUser = async (user, file) => {
  const completeUser = {
    connection: CONNECTION,
    email: user.email,
    email_verified: false,
    verify_email: false,
    app_metadata: {
      roles: user.app_metadata.roles,
      address: BLOCKCHAINADDRESS,
      authorized: true,
      realAccount: user.app_metadata.realAccount,
    },
    user_metadata: {
      type: user.user_metadata.type,
      consumingSites: user.user_metadata.consumingSites,
      logo: '',
      username: user.user_metadata.username,
      firstname: user.user_metadata.firstname,
      lastname: user.user_metadata.lastname,
      phoneNumber: user.user_metadata.phoneNumber,
      organization: user.user_metadata.organization,
    },
  };

  if (
    user.user_metadata.organization.type === enums.OrganizationTypes.CUSTOMER
  ) {
    completeUser.user_metadata.consumingAssets =
      user.user_metadata.consumingAssets;
  }

  let json = JSON.stringify(completeUser);

  let createdUserResponse = await fetch(
    process.env.REACT_APP_API_URL + '/api/users/',
    {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
      },
      body: json,
    }
  );

  let createdUser = await createdUserResponse.json();

  if (file) {
    let userId = createdUser.user_id.split('|')[1];
    completeUser.pictureFileName = await uploadUserPicture(
      file,
      createdUser,
      userId
    );
    completeUser.user_id = createdUser.user_id;

    await setUser(userId, completeUser).catch(error => {
      dispatch({ type: 'CREATE_USER_FAIL' });
      dispatch({ type: 'OPEN_ERROR', payload: 'Error creating user' });
    });
  }

  return createdUser;
};

export const userPictureChanged = file => dispatch => {
  dispatch({ type: 'USER_PICTURE_CHANGED', payload: file });
};

const uploadUserPicture = async (file, user, userId) => {
  var formData = new FormData();
  formData.append('files', file);

  const pictureFileName = await fetch(
    process.env.REACT_APP_API_URL + '/api/users/upload-file/' + userId,
    {
      method: 'POST',
      credentials: 'include',
      body: formData,
    }
  )
    .then(function(response) {
      return response.json();
    })
    .then(function(body) {
      return body;
    });

  return pictureFileName;
};

export const getConsumptionSiteData = async consumptionSiteId => {
  try {
    let response = await fetch(
      process.env.REACT_APP_API_URL + '/api/consum/' + consumptionSiteId,
      {
        method: 'GET',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
      }
    );

    handleErrors(response);

    let data = await response.json();

    return data;
  } catch (error) {
    handleCatchedErrors(error);
  }
};

const setUser = async (userId, user) => {
  const json = JSON.stringify(user);

  return await fetch(process.env.REACT_APP_API_URL + '/api/users/' + userId, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
    body: json,
  })
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(error => error);
};

export const getAuthenticatedUser = async () => {
  return await fetch(process.env.REACT_APP_API_URL + '/api/users/current', {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  })
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data;
    })
    .catch(error => error);
};

export const getUserMatchingFrequency = async () => {
  //TODO understand why with AP or LB we don't get the organization from currentUser
  let currentUserDb = await getAuthenticatedUser();

  let utilityOrganization;
  if (currentUserDb.organization.type === enums.OrganizationTypes.UTILITY) {
    utilityOrganization = await getOrganization(currentUserDb.organization._id);
  }
  if (currentUserDb.organization.type === enums.OrganizationTypes.CUSTOMER) {
    utilityOrganization = await getOrganization(
      currentUserDb.organization.parentOrganization
    );
  }

  let frequency =
    utilityOrganization &&
    utilityOrganization.matchingType &&
    utilityOrganization.matchingType.frequency
      ? utilityOrganization.matchingType.frequency
      : null;

  return frequency;
};



// WEBPACK FOOTER //
// ./src/actions/UsersActions.js